var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "nav",
      {
        staticClass:
          "bg-blue-800 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
      },
      [
        _c("div", { staticClass: "flex flex-wrap items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "flex flex-shrink md:w-1/3 justify-center md:justify-start text-white"
            },
            [
              _c("router-link", { attrs: { to: { name: "Dashboard" } } }, [
                _c("div", { staticClass: "w-20 p-2 ml-10" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/logo-dashboard.png") }
                  })
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex w-full pt-2 content-center justify-between md:w-1/3 md:justify-end"
            },
            [
              _c(
                "ul",
                {
                  staticClass:
                    "list-reset flex justify-between flex-1 md:flex-none items-center h-10"
                },
                [
                  _c("li", { staticClass: "flex-1 md:flex-none md:mr-3" }, [
                    _c("div", { staticClass: "relative inline-block" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "drop-button text-white focus:outline-none",
                          on: {
                            click: function($event) {
                              return _vm.toggleDD()
                            }
                          }
                        },
                        [
                          _vm._m(1),
                          _vm._v(
                            " Hi,\n                " +
                              _vm._s(_vm.getName) +
                              "\n                "
                          ),
                          _c(
                            "svg",
                            {
                              staticClass: "h-3 fill-current inline",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 20 20"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdownlist w-40 absolute bg-gray-900 text-white right-0 mt-3 p-3 overflow-auto z-30",
                          staticStyle: { display: "none" },
                          attrs: { id: "myDropdown" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block",
                              on: {
                                click: function($event) {
                                  return _vm.toggleDD("profile")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Profile\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isSuperAdmin
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleDD(
                                        "change-password-user"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Change Password\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "border border-gray-800" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block",
                              on: { click: _vm.logout }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-sign-out-alt fa-fw"
                              }),
                              _vm._v(" Log Out")
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex flex-col md:flex-row overflow-y-hidden max-h-screen-musicverse"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "bg-blue-800 shadow-lg h-16 fixed bottom-0 mt-12 md:relative md:h-screen z-10 w-full md:w-56"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "md:mt-20 md:w-56 md:fixed md:left-0 md:top-0 content-center md:content-start text-left justify-between overflow-y-auto pb-6",
                staticStyle: { height: "90vh" }
              },
              [
                _c(
                  "ul",
                  {
                    staticClass:
                      "list-reset flex flex-row md:flex-col py-0 md:py-3 px-1 md:px-2 text-center md:text-left "
                  },
                  [
                    !_vm.isReviewer && !_vm.isRecruitment && !_vm.isFinance
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "Statistic" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-pink-500",
                                    class:
                                      _vm.currentRoute === "Statistic"
                                        ? "border-pink-500"
                                        : "",
                                    attrs: { href: "#" }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "chart-line"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Home")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps ||
                    _vm.isAdmin ||
                    _vm.isSuperAdmin ||
                    _vm.isReviewer
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: _vm.isReviewer
                                      ? "HomeSection"
                                      : "AdsSettings"
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "cogs"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("App Settings")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isAppSettingMenu
                              ? _c("ul", [
                                  !_vm.isReviewer
                                    ? _c(
                                        "li",
                                        { staticClass: "ml-5 flex-1" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "AdsSettings" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "AdsSettings"
                                                      ? "border-yellow-500"
                                                      : ""
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Ads")]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          false
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "SkipQuotaSettings"
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                      class:
                                                        _vm.currentRoute ===
                                                        "SkipQuotaSettings"
                                                          ? "border-yellow-500"
                                                          : ""
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                        },
                                                        [_vm._v("Skip Quota")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isReviewer
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name:
                                                        "AccountDeletionSurvey"
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                      class:
                                                        _vm.currentRoute ===
                                                        "AccountDeletionSurvey"
                                                          ? "border-yellow-500"
                                                          : ""
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Account Deletion Survey"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "HomeSection" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                      "HomeSection" ||
                                                    _vm.currentRoute ===
                                                      "HomeSectionDetail"
                                                      ? "border-yellow-500"
                                                      : ""
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Home Section")]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "OnboardingBanner" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "OnboardingBanner"
                                                      ? "border-yellow-500"
                                                      : ""
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Onboarding Banner"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "ReferralBanner" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "ReferralBanner"
                                                      ? "border-yellow-500"
                                                      : ""
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Referral Banner")]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "ReferralAbout" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "ReferralAbout"
                                                      ? "border-yellow-500"
                                                      : ""
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Referral About")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: { name: "MusicCategoriesPage" } }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "list-ul"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Categories")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isCategoriesMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "MusicCategoriesPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "MusicCategoriesPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Music Categories")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "MissionCategoriesPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "MissionCategoriesPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [
                                                  _vm._v(
                                                    "Missions Videos Categories"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/missions-videos" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-blue-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "video"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block overflow-ellipsis"
                                      },
                                      [_vm._v("Missions Videos")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isMissionsVideosMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "ChannelListPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "ChannelListPage"
                                                  ? "border-blue-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Channel List")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "RecommendedVideosPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "RecommendedVideosPage"
                                                  ? "border-blue-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Recommended Video")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdmin || _vm.isSuperAdmin || _vm.isReviewer
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "ListPlaylist" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-pink-500",
                                    class: _vm.isPlaylistMenu
                                      ? "border-pink-500"
                                      : "",
                                    attrs: { href: "#" }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "play-circle"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Playlist")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "Users" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "users"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Users")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isUserMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        { attrs: { to: { name: "Users" } } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute === "Users"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("App Users")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isSuperAdmin
                                    ? _c(
                                        "li",
                                        { staticClass: "ml-5 flex-1" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "UsersAdmin" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "UsersAdmin"
                                                      ? "border-yellow-500"
                                                      : ""
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Admin Users")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "UsersDeletedPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "UsersDeletedPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Deleted App Users")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps ||
                    _vm.isAdmin ||
                    _vm.isSuperAdmin ||
                    _vm.isRecruitment
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c("router-link", { attrs: { to: "/artists" } }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-green-500"
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "pt-3 pr-0 md:pr-3",
                                    attrs: { icon: ["fa", "drum"], size: "2x" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                    },
                                    [_vm._v("Artists")]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.isArtistManagementMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        { attrs: { to: { name: "Artists" } } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                  "Artists" ||
                                                _vm.currentRoute ===
                                                  "DetailArtistPage" ||
                                                _vm.currentRoute ===
                                                  "AddArtistPage"
                                                  ? "border-red-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Artist List")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "DraftArtistPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "DraftArtistPage"
                                                  ? "border-red-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Draft")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isFinance
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: !_vm.isArtist
                                      ? "SongManagement"
                                      : "Album"
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "music"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Content")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isAlbumMenu
                              ? _c("ul", [
                                  !_vm.isArtist
                                    ? _c(
                                        "li",
                                        { staticClass: "ml-5 flex-1" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "SongManagement" }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "SongManagement"
                                                      ? "border-purple-500"
                                                      : ""
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass:
                                                      "pt-3 pr-0 md:pr-3",
                                                    attrs: {
                                                      icon: [
                                                        "fa",
                                                        "angle-right"
                                                      ],
                                                      size: "2x"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Songs")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        { attrs: { to: "/album" } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute === "Album"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass:
                                                  "pt-3 pr-0 md:pr-3",
                                                attrs: {
                                                  icon: ["fa", "angle-right"],
                                                  size: "2x"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Albums")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isArtist
                                    ? _c(
                                        "li",
                                        { staticClass: "ml-5 flex-1" },
                                        [
                                          _c(
                                            "router-link",
                                            { attrs: { to: "/artist-bio" } },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                                  class:
                                                    _vm.currentRoute ===
                                                    "ArtistBio"
                                                      ? "border-purple-500"
                                                      : ""
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass:
                                                      "pt-3 pr-0 md:pr-3",
                                                    attrs: {
                                                      icon: [
                                                        "fa",
                                                        "angle-right"
                                                      ],
                                                      size: "2x"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                    },
                                                    [_vm._v("Bio")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isArtist
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/purchase-history" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-red-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "chart-bar"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Transactions")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isTransactionsMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "StreamListPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "StreamListPage"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Stream")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "Transactions" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "Transactions"
                                                  ? "border-red-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Purchase")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: { to: { name: "EarningPage" } }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "EarningPage"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Earnings")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/tnc-management" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-blue-500",
                                    class:
                                      _vm.currentRoute === "TncManagement"
                                        ? "border-blue-500"
                                        : ""
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "file-contract"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block overflow-ellipsis"
                                      },
                                      [_vm._v("Term of Service")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/credits-amount" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-red-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "money-bill"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Pricing")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isPricingMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "CreditsAmount" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "CreditsAmount"
                                                  ? "border-red-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Credits Amount")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "SubscriptionSettingPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "SubscriptionSettingPage"
                                                  ? "border-red-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Subscription")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "IapManagement" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "IapManagement"
                                                  ? "border-red-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("In-App Purchase")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/transaction-history" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-red-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fas", "clipboard-list"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Transactions")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isTransactionsAdminMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "TransactionHistoryPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "TransactionHistoryPage"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Content Purchase")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "CreditPurchasePage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "CreditPurchasePage"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Credit Purchase")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "SubscriptionHistoryPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "SubscriptionHistoryPage"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Subscription")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "RedemptionHistoryPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "RedemptionHistoryPage"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Redemption")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isArtist && !_vm.isRecruitment && !_vm.isReviewer
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "PayoutList" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "chart-bar"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Finance")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isFinanceMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: { to: { name: "PayoutList" } }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "PayoutList"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Payout List")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "TransferHistory" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "TransferHistory"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Transfer History")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "RatingList" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "star"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Rating and Survey")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isRatingSurveyMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: { to: { name: "RatingList" } }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "RatingList"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Ratings")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: { to: { name: "SurveyList" } }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "SurveyList"
                                                  ? "border-purple-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Survey")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { name: "ReferralDataBannerPage" }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "users"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Referral Data")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isReferralDataMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "ReferralDataBannerPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "ReferralDataBannerPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Banner Click")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "ReferralDataSharePage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "ReferralDataSharePage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Share Click")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "ReferralDataMemberPage"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "ReferralDataMemberPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Referred Member")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "FirstTimeSubsPage" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "users"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("Subscription")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isSubscriptionMenu
                              ? _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "FirstTimeSubsPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "FirstTimeSubsPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("First Time")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "ml-5 flex-1" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "CancelExpireSubsPage" }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500",
                                              class:
                                                _vm.currentRoute ===
                                                "CancelExpireSubsPage"
                                                  ? "border-yellow-500"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                                },
                                                [_vm._v("Cancel & Expire")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdmin || _vm.isSuperAdmin
                      ? _c(
                          "li",
                          { staticClass: "mr-3 flex-1" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "CLTVPage" } } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "pt-3 pr-0 md:pr-3",
                                      attrs: {
                                        icon: ["fa", "users"],
                                        size: "2x"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                                      },
                                      [_vm._v("CLTV")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("ModalTermAndConditions", {
          attrs: {
            isShowingModal: _vm.isShowingModalTermsandCondition,
            isHideToggle: true,
            isLoading: _vm.isLoading
          },
          on: {
            save: function($event) {
              return _vm.processAcceptToc()
            }
          }
        }),
        _vm._v(" "),
        _c("router-view")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex flex-1 md:w-1/3 justify-center md:justify-start text-white px-2"
      },
      [_c("span", { staticClass: "relative w-full" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "pr-2" }, [
      _c("i", { staticClass: "em em-robot_face" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ba47ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba47ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = null
// module chunks = 